import React from 'react'
import '../CustomDomain.css'

const CustomDomainBanner = ({ onSearch }) => {
  return (
    <div className="custom-domain-banner">
      <div className="banner-content">
        <div className="banner-left">
          <div className="banner-header">
            <div className="icon-container">
              <img className="globe-icon" src="/assets/icons/globe-24.svg" alt="globe-icon" width="24" height="24" />
            </div>
            <h3 className="banner-title">Get a custom domain for your project</h3>
          </div>
          <div>
            <button className="search-button" onClick={onSearch}>
              <span>Search for domain</span>
              <span className="search-arrow">→</span>
            </button>
          </div>
        </div>

        <div className="banner-right">
          <div className="price-label">Starting from as little as</div>
          <div className="price-display">
            <span className="price-amount">$1</span>
            <span className="price-period-style">/mo</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomDomainBanner
